import { combineReducers } from 'redux';

import { rtkApi, rtkNoAuthApi } from '../rtk';
import { rtkEngineApi } from '../rtk/engine';
import activity from './activity';
import alerts from './alert';
import apiReducer from './api';
import coverageReducer from './coverage';
import jobsReducer from './jobs';
import layout from './layout';
import mapReducer from './map';
import modal from './modal';
import order from './order';
import productsReducer from './products';
import profileReducer from './profile';
import project from './project';
import tourReducer from './tour';
import mpReducer from './mp';
import { orderV2Slice } from './order.v2';

const rootReducer = combineReducers({
  layout,
  alerts,
  jobsReducer,
  profileReducer,
  productsReducer,
  mapReducer,
  modal,
  activity,
  order,
  project,
  coverageReducer,
  tourReducer,
  apiReducer,
  [orderV2Slice.name]: orderV2Slice.reducer,
  [rtkApi.reducerPath]: rtkApi.reducer,
  [rtkNoAuthApi.reducerPath]: rtkNoAuthApi.reducer,
  [rtkEngineApi.reducerPath]: rtkEngineApi.reducer,
  mpReducer,
});

export default rootReducer;
